import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsDownloadPdfTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_DOWNLOAD_PDF;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_PDF_DOWNLOAD_REPORT;

	get id(): string {
		return TourId.REPORTS__DOWNLOAD_PDF;
	}

	override get keyForPersistantDone(): string {
		return ReportsDownloadPdfTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				allowStacked: false,
				attachTo: () => {
					return $('#report-editor_head .download');
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
